import styled from 'styled-components';

import { ReactComponent as SVG } from 'assets/warning.svg';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 3.2rem;
`;

const Title = styled(Headline)`
  margin-top: 2.4rem;
  text-align: center;
`;

const Icon = styled(SVG)`
  width: 3rem;
  height: 3rem;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;

  margin-top: 3.2rem;
`;

export { Container, Title, Buttons, Icon };
